import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MuiSelect, {SelectProps as MuiSelectProps} from '@mui/material/Select';
import {styled} from '@mui/material/styles';
import React from 'react';
import {Input, InputProps} from '../Input';
import {FuelInputVariant} from '../types/general';

export interface SelectProps<T = InputProps | any> extends Omit<MuiSelectProps, 'variant' | 'inputProps' | 'input'> {
    variant?: FuelInputVariant;
    InputComponent?: React.ComponentType<T>;
    inputProps?: T;
}

const StyledSelect = styled(MuiSelect)<SelectProps>({
    '& .MuiInputBase-input.MuiSelect-select': { // forcing specificity
        paddingRight: 'calc((1.5rem + 0.5rem * 2) - 1px)' // -1 for border
    },
    '& .MuiSelect-icon': {
        right: '7px' // not '8px' or '1rem' to accommodate for border width of 1px
    }
});

export const Select = React.forwardRef<any, SelectProps>(({
    id, children, onClick, className, fullWidth, inputRef, inputProps,
    IconComponent = KeyboardArrowDownIcon, InputComponent = Input, name,
    variant, size = 'medium', ...props
}, ref) => (
    <StyledSelect
        {...props}
        IconComponent={IconComponent}
        className={className}
        displayEmpty
        fullWidth={fullWidth}
        input={(
            <InputComponent
                id={id}
                inputProps={inputProps}
                inputRef={inputRef}
                ref={ref}
                size={inputProps?.size || size}
                variant={inputProps?.variant || variant}
            />
        )}
        ref={ref}
    >
        {children}
    </StyledSelect>
));

Select.displayName = 'Select';
